module.exports = __webpack_public_path__ + "img/campfire.6894d8ba.svg";